import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from 'record-it-components/form/FormGroup/FormGroup';
import { useSpecificParams } from 'record-it-components/hooks/useSpecificParams/useSpecificParams';
import { MessageBox, MessageBoxType } from 'record-it-components/misc/MessageBox/MessageBox';
import { PageContentContainer } from 'record-it-components/pageContentLayout/PageContentContainer/PageContentContainer';
import { PageContentHeader } from 'record-it-components/pageContentLayout/PageContentHeader/PageContentHeader';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useEntityByIdOrOriginalId } from '../../../hooks/entity/useEntityByIdOrOriginalId';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { TrackedWorkTimeLine } from '../../timeTracking/TrackedWorkTimeLine/TrackedWorkTimeLine';
import { WorkTimeEntryActivityWidget } from '../../workTime/WorkTimeEntryActivityWidget/WorkTimeEntryActivityWidget';
import { WorkTimeEntryNoteWidget } from '../../workTime/WorkTimeEntryNoteWidget/WorkTimeEntryNoteWidget';
export type EditWorkTimeEntryPageProps = PropsWithoutChildren<Record<never, never>>;
export const EditWorkTimeEntryPage: FunctionComponent<EditWorkTimeEntryPageProps> = React.memo(props => {
  const $ = _c(13);
  prepareProps({
    props,
    ignoreChildren: true
  });
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      requiredParamNames: ["workTimeEntryId"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    workTimeEntryId
  } = useSpecificParams(t0);
  let t1;
  if ($[1] !== workTimeEntryId) {
    t1 = builder => builder.addHomePage().addMyWorkTimeOverviewPage().addEditWorkTimeEntryPage(workTimeEntryId);
    $[1] = workTimeEntryId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useConfigureBreadcrumbsWithBuilder(t1);
  const workTimeEntry = useEntityByIdOrOriginalId(EntityName.WorkTimeEntry, workTimeEntryId);
  const {
    t
  } = useTranslation();
  let t2;
  if ($[3] !== t) {
    t2 = t("components.page.EditWorkTimeEntryPage.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <PageContentHeader title={t2} iconConfig={iconConfigurations.prefixed.page.EditWorkTimeEntryPage.titleIcon} />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t || $[8] !== workTimeEntry) {
    t4 = workTimeEntry ? <><FormGroup><WorkTimeEntryActivityWidget workTimeEntry={workTimeEntry} /><WorkTimeEntryNoteWidget workTimeEntry={workTimeEntry} /></FormGroup><TrackedWorkTimeLine startDate={workTimeEntry.startDate} endDate={workTimeEntry.endDate} workTimeEntryBreaks={workTimeEntry.breaks} data-testid="EditWorkTimeEntryPage.TrackedWorkTimeLine" /></> : <MessageBox type={MessageBoxType.Error} data-testid="EditWorkTimeEntryPage.EntryNotFoundMessageBox">{t("components.page.EditWorkTimeEntryPage.entryNotFound")}</MessageBox>;
    $[7] = t;
    $[8] = workTimeEntry;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <PageContentContainer>{t3}{t4}</PageContentContainer>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
});